import { render } from "./Login_sbm.vue?vue&type=template&id=3449f7ba&scoped=true"
import script from "./Login_sbm.vue?vue&type=script&lang=js"
export * from "./Login_sbm.vue?vue&type=script&lang=js"

import "./Login_sbm.vue?vue&type=style&index=0&id=3449f7ba&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3449f7ba"]])

export default __exports__